import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { AppConstants } from '../util/app-constants';

@Pipe({
  name: 'dateTime',
  standalone: false
})
export class DateTimePipe implements PipeTransform {
  private readonly defaultDateFormat = AppConstants.DEFAULT_DATE_FORMAT;

  transform(date: number, format: string): string {
    const dateFormat = format || this.defaultDateFormat;
    return moment(date * 1000).format(dateFormat);
  }

}
